import type {
  AppPaddleButtonProps,
  AppPaddleButtonState,
} from "./AppPaddleButton.types";

// eslint-disable-next-line no-restricted-imports
import { useAppButton } from "@1js/acui-button/lib/Next";
import { useAppPaddleButtonDataIsFocusable } from "./useAppPaddleButtonDataIsFocusable";
import { useOnExecute } from "./useOnExecute";

export const useAppPaddleButton = (
  props: AppPaddleButtonProps,
  ref: React.Ref<HTMLButtonElement>
): AppPaddleButtonState => {
  const onExecute = useOnExecute(props);

  const state = useAppButton(
    {
      ...props,
      onExecute,
      tabIndex: -1,
      takeFocusOnClick: false,
      hideLabel: true,
    },
    ref
  ) as AppPaddleButtonState;

  state.orientation = props.orientation;

  state.disableModeTogglePadding = props.disableModeTogglePadding;

  useAppPaddleButtonDataIsFocusable(state);

  return state;
};
